export class GMServiceVisitByDealerQueryParameters {
  advisorId?: string;
  destinationId?: string;

  constructor(obj?: GMServiceVisitByDealerQueryParameters) {
    if (obj) {
      Object.assign(this, obj);
    }
  }
}
